export const PdfExportColumns = (summaryUnitLabels) => {
    return [
        {
          title: "Waypoint",
          dataKey: "title",
        },
        {
          title: "Distance (" + summaryUnitLabels[1] + ") \n[from previous point]",
          dataKey: "distance",
        },
        {
          title: "Elevation\nchange (" + summaryUnitLabels[2] + ")",
          dataKey: "elevChange",
        },
        {
          title: "Time\n[from previous point]",
          dataKey: "elapsedTime",
        },
        {
          title: "Pace",
          dataKey: "pace",
        },
        {
          title: "Notes",
          dataKey: "description",
        },
      ];
    };  